import React, { useEffect, useState } from "react";
import "./steps.css";
import Hexapi from "../../../utility/HexAPI/Hexapi";
import TooltipButton from "../../../components/tooltip/Popover";
import Categorypic from "../../../components/categorypiker/Categorypic";
import getMeetingTime from "../utility/getMeetingTime";
import dayjs from "dayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import GetImage from "../../../components/getimage/Getimage";


export default function Step2({ userid, formData = {}, setFormData = () => {}, meetingid }) {
  const [pendinglist, setpendinglist] = useState([]);

  const handleTimeChange = (newTime) => {
    setFormData({
      ...formData,
      meetingTime: newTime || null,
    });
  };

  const getPendingListData = async () => {
    const today = dayjs(formData?.Date);
    const dayId = today.format("YYMMDD");
    const CurMeetingID = meetingid == undefined ? -1 : meetingid;

    try {
      const obj = {
        query: `HRApp_Droid_Proc_AddMeeting_PendingMeeting_GetList @UserID = '{0}' , @DayID='{1}',@CurMeetingID='{2}'`,
        queryArr: [`${userid}`, `${dayId}`, `${CurMeetingID}`],
      };
      const resp = await Hexapi(obj);
console.log(resp,"resppssss")
      if (resp && resp[""]) {
        setpendinglist(resp[""]);
      } else {
        setpendinglist([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userid) {
      getPendingListData();
    }
  }, [userid, formData?.Date]);

  const circle1 = {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#60a5fa",
    border: "2px solid white",
    zIndex: 1,
  };

  const circle2 = {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#f87171",
    border: "2px solid white",
    marginLeft: "-11px",
    zIndex: 2,
  };

  const countCircle = {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#9ca3af",
    border: "2px solid white",
    marginLeft: "-11px",
    zIndex: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "10px",
    fontWeight: "600",
    color: "white",
  };

  return (
    <div className="row">
      <div className="col-6">
        <div className="top-section">
          <p className="selectmeetingtime" style={{ fontWeight:600 }}>Select Meeting Time <TooltipButton fieldName={"MeetingTime"}/></p>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              value={formData.meetingTime || null}
              onChange={handleTimeChange}
              minutesStep={1}
              ampm={true}
              format="hh:mm A"
              timeSteps={{ minutes: 1 }}
              open={true}
              closeOnSelect={true}
              slotProps={{
                 actionBar: { actions: [] },
                textField: {
                  fullWidth: true,
                  size: "small",
                },
              }}
            />
          </LocalizationProvider>
          
             
        </div>
      </div>


      <div className="col-6">
        <div className="bottom-section">
          <div style={{ fontWeight: "500", marginBottom: "20px" }}>
            Your Pending Meetings{" "}
            <span>
              <TooltipButton fieldName={"MeetingPending"} />
            </span>
          </div>

          <div>
            {pendinglist.length > 0 ? (
              pendinglist.map((res, index) => {
                const empIds = res?.empids?.split(",") || [];
                return (
                  <div
                    key={index}
                    style={{
                      border: "1px solid #ddd",
                      boxSizing: "border-box",
                      padding: "6px",
                      borderRadius: "8px",
                      marginBottom: "10px",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex gap-2">
                        <div style={{ width: "45px", height: "45px" }}>
                          <Categorypic categoryID={res.categoryid} />
                        </div>

                        <div>
                          <p style={{ marginBottom: "0px" }} className="colorset">
                            {res.name}
                          </p>
                          <span style={{ color: "#374151", fontSize: "12px" }}>
                            {getMeetingTime(res?.scheduledtime?.date)}
                          </span>{" "}
                          -
                          <span style={{ color: "#374151", fontSize: "12px" }}>
                            {getMeetingTime(res?.endtime?.date)}
                          </span>
                        </div>
                      </div>

                      <div>
                        {
                         (res.empids && res?.attendees > 0 )&& (
                            <div style={{ display: "flex", alignItems: "center" }}>
                              
                             
                            {empIds[0] && (
                            <div style={circle1}>
                              <GetImage imgID={empIds[0]} width="100%" height="100%" />
                            </div>
                          )}
                        
                              {res?.attendees >= 2 && (
                                 <div style={circle2}>
                              <GetImage imgID={empIds[1]} width="100%" height="100%" />
                            </div>
                              )}
                        
                              {res?.attendees > 2 && (
                                <div style={countCircle}>
                                  +{res.attendees - 2}
                                </div>
                              )}
                        
                            </div>
                          )
                        }
                        {!res.empids && res?.attendees > 0 && (
                          <div style={{ display: "flex", alignItems: "center" }}>
                              <div style={countCircle}>{res.attendees}</div>
                            
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p style={{ color: "#ff6d00" }}>No pending meetings!</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}